import { render, staticRenderFns } from "./preMemorialHall.vue?vue&type=template&id=b91cf4b6&scoped=true"
import script from "./preMemorialHall.vue?vue&type=script&lang=js"
export * from "./preMemorialHall.vue?vue&type=script&lang=js"
import style0 from "./preMemorialHall.vue?vue&type=style&index=0&id=b91cf4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91cf4b6",
  null
  
)

export default component.exports